import { keyframes } from '@emotion/react';
var indeterminateAnimation = keyframes({
    '0%': {
        left: 0,
        width: '30%',
        backgroundPositionX: '0%'
    },
    '50%': {
        left: '70%',
        width: '30%',
        backgroundPositionX: '100%'
    },
    '100%': {
        left: 0,
        width: '30%',
        backgroundPositionX: '0%'
    }
});
var SMALL_BAR_MIN_WIDTH = '100px';
var SMALL_BAR_MAX_WIDTH = '150px';
var LARGE_BAR_MIN_WIDTH = '300px';
var LARGE_BAR_MAX_WIDTH = '350px';
var MEDIUM_BAR_MIN_WIDTH = '200px';
var MEDIUM_BAR_MAX_WIDTH = '250px';
export var getStyle = function (_a) {
    var theme = _a.theme;
    return {
        outer: {
            fontFamily: theme.font.base.family,
            fontSize: theme.font.base.size.h4,
            fontWeight: theme.font.base.weight.regular,
            color: theme.font.color.base,
            justifyContent: 'center',
            position: 'relative',
            textAlign: 'center'
        },
        barContainer: {
            base: {
                width: '100%',
                background: theme.backgroundColor.active,
                height: '5px',
                borderRadius: '100vw',
                position: 'relative',
                overflow: 'visible',
                margin: '24px auto 24px auto'
            },
            s: {
                minWidth: SMALL_BAR_MIN_WIDTH,
                width: '100%',
                maxWidth: SMALL_BAR_MAX_WIDTH
            },
            m: {
                minWidth: MEDIUM_BAR_MIN_WIDTH,
                width: '100%',
                maxWidth: MEDIUM_BAR_MAX_WIDTH
            },
            l: {
                minWidth: LARGE_BAR_MIN_WIDTH,
                width: '100%',
                maxWidth: LARGE_BAR_MAX_WIDTH
            }
        },
        barProgressBar: {
            base: {
                height: '5px',
                borderRadius: '40px',
                opacity: 1,
                backgroundSize: '100% 5px',
                transition: "clip-path " + theme.transition.duration.default + " linear, -webkit-clip-path " + theme.transition.duration.default + " linear, width " + theme.transition.duration.default + " linear, background 2s linear, left 2s linear, background-image 2s linear, opacity 2s linear ",
                display: 'block',
                position: 'relative'
            }
        },
        indeterminate: {
            base: {
                // other option 1:
                backgroundSize: '333%',
                // Typescript can't handle the complexity of the template literal unions so we cast it as a string
                backgroundImage: "linear-gradient( to right, " + theme.backgroundColor.accent.fill.base + ", " + theme.backgroundColor.tertiary.fill.base + ",  " + theme.backgroundColor.brand.fill.focus + " )",
                animation: indeterminateAnimation + "  3.5s ease-in-out infinite"
            }
        }
    };
};
